import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import XAISandbox from '../components/XAISandbox';

const XAIDemo = () => {
  const params = useParams();
  const location = useLocation();

  const platformId = params.platformId || location.state?.platformId || 'multimodal';
  const exampleIndex = params.exampleIndex || location.state?.exampleIndex || 0;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-indigo-50">
      <XAISandbox 
        platformId={platformId}
        exampleIndex={exampleIndex}
      />
    </div>
  );
};

export default XAIDemo;
